<template>
  <div class="login-container">
    <div class="login-box bg-white radius-20 w-520 padding-bottom-40">
      <div class="text-center padding-top-40 padding-bottom-30 text-bold text-main text-32">忘记密码</div>
      <el-form ref="forgotPasswordForm" :model="forgotPasswordForm" :rules="forgotPasswordRules"
        class="login-form w-450" label-width="0">
        <el-form-item prop="username">
          <el-input v-model="forgotPasswordForm.username" placeholder="手机号/邮箱" size="large" class="custom-input"
            @keyup.enter.native="handleSubmit">
            <template slot="prefix">
              <img :src="icon1" alt="icon" class="input-icon" />
            </template>
          </el-input>
        </el-form-item>

        <el-form-item prop="code">
          <el-input v-model="forgotPasswordForm.code" placeholder="验证码" size="large" class="custom-input code-input"
            @keyup.enter.native="handleSubmit">
            <template slot="prefix">
              <img :src="icon3" alt="icon" class="input-icon" />
            </template>
            <template slot="suffix">
              <el-button 
                :disabled="countdown > 0" 
                type="text" 
                class="get-code-btn text-main text-bold"
                @click="getVerificationCode">
                {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-input v-model="forgotPasswordForm.newPassword" type="password" placeholder="请输入新密码" size="large" class="custom-input"
            show-password @keyup.enter.native="handleSubmit">
            <template slot="prefix">
              <img :src="icon3" alt="icon" class="input-icon" />
            </template>
          </el-input>
        </el-form-item>
        <el-button type="primary" size="large" :loading="loading" class="login-button radius-100 bg-main margin-top-10"
          @click="handleSubmit">
          确定
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sendSmsCode, resetPassword } from '@/api/user';

export default {
  name: 'ForgotPassword',
  data() {
    // 自定义用户名验证规则
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'));
      } else if (value.length < 3) {
        callback(new Error('用户名长度不能少于3个字符'));
      } else {
        callback();
      }
    };

    // 自定义验证码验证规则
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'));
      } else if (value.length < 4) {
        callback(new Error('验证码长度不能少于4位'));
      } else {
        callback();
      }
    };

    // 自定义新密码验证规则
    const validateNewPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'));
      } else if (value.length < 6) {
        callback(new Error('密码长度不能少于6个字符'));
      } else {
        callback();
      }
    };

    return {
      checked: false,
      icon1: require('@/assets/images/icon1.png'),
      icon3: require('@/assets/images/icon3.png'),
      countdown: 0,
      countdownTimer: null,
      forgotPasswordForm: {
        username: '',
        code: '',
        newPassword: ''
      },
      forgotPasswordRules: {
        username: [
          { validator: validateUsername, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ],
        newPassword: [
          { validator: validateNewPassword, trigger: 'blur' }
        ]
      },
      loading: false
    };
  },
  methods: {
    // 获取验证码
    getVerificationCode() {
      // 验证手机号/邮箱是否填写
      if (!this.forgotPasswordForm.username) {
        this.$message.warning('请先输入手机号/邮箱');
        return;
      }

      // 验证手机号或邮箱格式
      const phoneReg = /^1[3-9]\d{9}$/;
      const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      
      if (!phoneReg.test(this.forgotPasswordForm.username) && !emailReg.test(this.forgotPasswordForm.username)) {
        this.$message.warning('请输入正确的手机号或邮箱格式');
        return;
      }

      // 如果正在倒计时，不允许重复点击
      if (this.countdown > 0) {
        return;
      }

      // 调用发送验证码接口
      sendSmsCode(this.forgotPasswordForm.username, 'resetpwd')
        .then(response => {
          this.$message.success('验证码已发送');
          
          // 开始倒计时
          this.countdown = 60;
          this.countdownTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.countdownTimer);
              this.countdownTimer = null;
            }
          }, 1000);
        })
        .catch(error => {
          this.$message.error(error.message || '验证码发送失败，请稍后重试');
        });
    },
    handleSubmit() {
      this.$refs.forgotPasswordForm.validate((valid) => {
        if (valid) {
          // 验证是否为手机号（重置密码接口需要手机号）
          const phoneReg = /^1[3-9]\d{9}$/;
          if (!phoneReg.test(this.forgotPasswordForm.username)) {
            this.$message.warning('重置密码需要使用手机号');
            return;
          }

          this.loading = true;

          // 调用重置密码接口
          resetPassword({
            mobile: this.forgotPasswordForm.username,
            newpassword: this.forgotPasswordForm.newPassword,
            captcha: this.forgotPasswordForm.code
          })
            .then(response => {
              this.loading = false;
              this.$message.success('密码重置成功！');
              
              // 提交成功后跳转到登录页
              setTimeout(() => {
                this.$router.push('/login');
              }, 1500);
            })
            .catch(error => {
              this.loading = false;
              this.$message.error(error.message || '密码重置失败，请稍后重试');
            });
        } else {
          this.$message.error('请填写完整的信息');
          return false;
        }
      });
    },
    goToLogin() {
      this.$router.push('/login');
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  background-image: url('@/assets/images/login.png');
  background-size: 100% 100%;
}

.login-box {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.5s ease-out;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


.login-form {
  margin: 0 auto;
}

.login-form .el-form-item {
  margin-bottom: 22px;
}

.custom-input {
  width: 450px;
  height: 62px;
}

.custom-input /deep/ .el-input__inner {
  width: 450px;
  height: 62px;
  line-height: 62px;
  padding-left: 55px;
}

.code-input /deep/ .el-input__inner {
  padding-right: 120px;
}

.get-code-btn {
  padding: 0 10px;
  height: 100%;
  border: none;
  background: transparent;
}

.get-code-btn:hover {
  background: transparent;
}

.get-code-btn:disabled {
  color: #999;
}

.custom-input /deep/ .el-input__prefix {
  left: 20px;
}

.input-icon {
  width: 17px;
  height: 20px;
  margin-top: 21px;
}

.login-button {
  width: 450px;
  height: 61px;
  border: none;
}
</style>
